export default "__VITE_ASSET__Dela9KXA__"